import { render, staticRenderFns } from "./TextEmbed.vue?vue&type=template&id=bf5408a0&scoped=true&"
import script from "./TextEmbed.vue?vue&type=script&lang=js&"
export * from "./TextEmbed.vue?vue&type=script&lang=js&"
import style0 from "./TextEmbed.vue?vue&type=style&index=0&id=bf5408a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5408a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf5408a0')) {
      api.createRecord('bf5408a0', component.options)
    } else {
      api.reload('bf5408a0', component.options)
    }
    module.hot.accept("./TextEmbed.vue?vue&type=template&id=bf5408a0&scoped=true&", function () {
      api.rerender('bf5408a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/Preview/TextEmbed.vue"
export default component.exports